'use client';

import { FC, useEffect } from 'react';
import { shallow } from 'zustand/shallow';

import { liveChatStore } from 'src/stores/liveChatStore';

export const Chat: FC = () => {
  const { visibility, setLiveChatVisibility } = liveChatStore(
    ({ visibility, setLiveChatVisibility }) => ({
      visibility,
      setLiveChatVisibility,
    }),
    shallow,
  );

  useEffect(() => {
    globalThis.window.LiveChatWidget?.call(getVisibility(visibility));
  }, [visibility]);

  useEffect(() => {
    const handleVisibilityChange = (data: { visibility: 'minimized' | 'maximized' | 'hidden' }) => {
      setLiveChatVisibility(data.visibility);
    };

    globalThis.window.LiveChatWidget?.on('visibility_changed', handleVisibilityChange);

    return () => {
      globalThis.window.LiveChatWidget?.off('visibility_changed', handleVisibilityChange);
    };
  }, [setLiveChatVisibility]);

  return null;
};

const getVisibility = (visibility?: string) => {
  switch (visibility) {
    case 'hidden':
      return 'hide';
    case 'minimized':
      return 'minimize';
    case 'maximized':
      return 'maximize';
    default:
      return 'hide';
  }
};
